import { render, staticRenderFns } from "./stats.component.vue?vue&type=template&id=fdad0858"
import script from "./stats.component.vue?vue&type=script&lang=js"
export * from "./stats.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports